module.exports = __webpack_public_path__ + "b27e8a41872fcce348bfb8aa1e1fc1fc.pdf";